import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-custom-page-description',
    templateUrl: './custom-page-description.component.html',
    styleUrls: ['./custom-page-description.component.scss'],
    standalone: false
})
export class CustomPageDescriptionComponent {
    @Input() text!: string;
}